import { render, staticRenderFns } from "./FormAddRunningShipment.vue?vue&type=template&id=1fe8933f&scoped=true"
import script from "./FormAddRunningShipment.vue?vue&type=script&lang=js"
export * from "./FormAddRunningShipment.vue?vue&type=script&lang=js"
import style0 from "./FormAddRunningShipment.vue?vue&type=style&index=0&id=1fe8933f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8933f",
  null
  
)

export default component.exports